module.exports = __webpack_public_path__ + "img/20.7d3c87e7.svg";